import logo from './../../../../assets/design-request/image_leather-dr_set-design_2022-b_1.jpg';

const DesignGuide = () => {
  return (
    <div className="w-full">
      <div className="relative flex justify-center items-center">
        <img className="mt-2" src={logo} alt="Emblem_Leather_Guide" />
      </div>
      <div className="mt-6 mb-6">
        <p>
          <b>Note:</b> We suggest your design has the following characteristics. Stahls
          designers are also here for you, to help determine the design features
          on files not uploaded in this format.
        </p>
        <ul className="list-disc list-inside mt-2">
          <li className="pl-6">
            Use a red <b>line</b> to specify the edge of your design
          </li>
          <li className="pl-6">
            Use color <b>white</b> to show the elements of your design that will keep the original
            <b> leather colour</b>
          </li>
          <li className="pl-6">
            Use colour black to show the<b> engraved</b> elements of your design
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DesignGuide;